import React from "react";

const Xicon71pxSvg = (props) => {
  return (
    <svg
      {...props}
      width="63"
      height="71"
      viewBox="0 0 63 71"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="10.4709"
        y="3.91211"
        width="69.4073"
        height="16.02"
        rx="8.00999"
        transform="rotate(40.8151 10.4709 3.91211)"
        fill="#006EFF"
      />
      <rect
        x="55.0608"
        y="8.05176"
        width="72.3588"
        height="16.019"
        rx="8.00948"
        transform="rotate(120.174 55.0608 8.05176)"
        fill="#006EFF"
      />
    </svg>
  );
};

export default Xicon71pxSvg;
